module.exports = __webpack_public_path__ + "img/navigationBgc_on.178c6670.png";